// extracted by mini-css-extract-plugin
module.exports = {"instagramContainer":"InstagramFeed_instagramContainer__3_PsP","socialIntro":"InstagramFeed_socialIntro__2c-Lj"};